import Navbar from "@/components/Navbar";
import SiteFooter from "@/components/SiteFooter";
import { useSiteContent } from "@/lib/content";
import { Sparkles } from "lucide-react";

export default function About() {
  const { content } = useSiteContent();
  const a = content?.about || {};
  const values = a.values || [];
  return (
    <div className="min-h-screen navy-glow flex flex-col" data-testid="about-page">
      <Navbar variant="public" />
      <main className="flex-1">
        <section className="max-w-5xl mx-auto px-6 py-16">
          <div className="chip mb-6">
            <Sparkles className="w-4 h-4" /> About Yonsii Geek Support
          </div>
          <h1 data-testid="about-heading" className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white tracking-tight">
            {a.heading || "Real geeks. Real fixes."}
          </h1>
          <p data-testid="about-mission" className="text-lg text-slate-300 mt-5 max-w-3xl leading-relaxed">
            {a.mission}
          </p>

          <div className="soft-card p-8 md:p-10 mt-10">
            <p data-testid="about-body" className="text-slate-700 text-[16px] leading-relaxed whitespace-pre-line">
              {a.body}
            </p>
          </div>

          {values.length > 0 && (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-10">
              {values.map((v, i) => (
                <div key={i} data-testid={`about-value-${i}`} className="soft-card p-6">
                  <div className="w-10 h-10 rounded-xl bg-brand text-white flex items-center justify-center font-bold shadow-btn">
                    0{i + 1}
                  </div>
                  <div className="font-display font-bold text-xl mt-4 text-slate-900">{v.title}</div>
                  <div className="text-slate-500 mt-2 leading-relaxed">{v.detail}</div>
                </div>
              ))}
            </div>
          )}
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}
